import { CircularProgress, Menu, styled } from "@mui/material";
import { FaFileCsv } from "react-icons/fa";
import { VscFilePdf } from "react-icons/vsc";

import { Button } from "../../../../../components/Form";
import { getBrandCustom } from "../../../../../util/getCustomColor";

export const MainDiv = styled("div")(() => ({
  padding: "32px",
  display: "flex",
  flexDirection: "column",
}));

export const PDFIconButton = styled(VscFilePdf)(() => ({
  cursor: "pointer",
}));

export const CSVIconButton = styled(FaFileCsv)(() => ({
  cursor: "pointer",
}));

export const PDFIconButtonDisabled = styled(VscFilePdf)(() => ({
  opacity: "0.5",
}));

export const CSVIconButtonDisabled = styled(FaFileCsv)(() => ({
  opacity: "0.5",
}));

export const ExportButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
}));

export const LoadingStyled = styled(CircularProgress)(() => ({
  color: "#475467",
}));

export const ReportOption = styled("li")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
}));

export const ReportOptionText = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
}));

export const ReportTitle = styled("span")(() => ({
  color: getBrandCustom("primaryColor", "#308CDB"),
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "24px",
  marginBottom: "23px",
}));

export const ExportMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    background: "#FFFFFF",
    fontFamily: "Manrope !important",
    fontSize: "12px",
    boxShadow: "0px 0px 5px rgba(71, 84, 103, 0.15)",
    borderRadius: "8px",
    width: "100px",
    color: "#667085",
    marginTop: "10px",
    "& .MuiMenu-list": {
      fontSize: "12px",
      "& :hover": {
        backgroundColor: "#EDF5FB !important",
        color: "#308CDB !important",
      },
    },
  },
}));

export const GridDiv = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  ".shipeezi-new-grid-component": {
    width: "100%",
  },
}));

export const EmptyDiv = styled("div")(() => ({
  border: "1px solid #eaebef",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  borderRadius: "5px",
  textAlign: "center",
  minHeight: "calc(100vh - 390px)",
}));
